import { InjectionToken } from "@angular/core";

/** server node provide this token to inject request mark value */
export const REQUEST_MARK_TOKEN = new InjectionToken<string>('REQUEST_MARK_TOKEN');
